import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const deliverySummary = css`
  display: flex;
  flex-direction: column;
  row-gap: var(${themeVariables.spacing.xxs});
  font-family: var(${themeVariables.typography.body.fontFamily});
  font-weight: var(${themeVariables.typography.body.fontWeight});
  font-size: var(${themeVariables.typography.body.sizes.md.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.md.lineHeight});
  text-decoration: none;
  color: var(${themeVariables.colors.content.default});
`;

export const orderBy = css`
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
  color: var(${themeVariables.colors.content.secondary});
`;

export const primaryLine = css`
  display: flex;
  align-items: center;
  column-gap: var(${themeVariables.spacing.xs});
  color: var(${themeVariables.colors.content.default});

  svg {
    flex-shrink: 0;
  }
`;

export const price = css`
  color: var(${themeVariables.colors.content.default});
`;

export const freePrice = css`
  color: var(${themeVariables.colors.content.positive});
`;

export const secondaryLine = css`
  display: flex;
  align-items: center;
  column-gap: var(${themeVariables.spacing.xxs});
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  line-height: var(${themeVariables.typography.body.sizes.sm.lineHeight});
  color: var(${themeVariables.colors.content.secondary});

  svg {
    flex-shrink: 0;
  }
`;
